module.exports = __webpack_public_path__ + "media/images/brand/meta_icons/favicon-32x32-f7922ac1ac41999a87e683360563a2af.png";